import React from "react";
import { SECTION_PADDING } from "../../constants/layout";
import PropTypes from "prop-types";

export const Section = ({ 
  children, 
  className = "", 
  spacing = true,
  as: Component = "section",
  ...props 
}) => (
  <Component 
    className={`${SECTION_PADDING} ${spacing ? 'space-y-4' : ''} ${className}`} 
    {...props}
  >
    {children}
  </Component>
);

Section.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  spacing: PropTypes.bool,
  as: PropTypes.elementType
};

export default Section; 